"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _solidUi = require("solid-ui");
var _EditContactsCard = require("./EditContactsCard");
var _EditFriendsCard = require("./EditFriendsCard");
var _EditSocialCard = require("./EditSocialCard");
var _EditCommunitiesCard = require("./EditCommunitiesCard");
require("../styles/utilities.css");
require("../styles/rdfFormsEnforced.css");
var _EditCVCard = require("./EditCVCard");
var _EditOtherPreferences = require("./EditOtherPreferences");
/**
 * Profile Editing App Pane
 *
 * Unlike view panes, this is available any place whatever the real subject,
 * and allows the user to edit their own profile.
 *
 * Usage: paneRegistry.register('/profile/editProfile.view')
 * or standalone script adding onto existing mashlib.
 */

const editProfileView = {
  global: true,
  icon: _solidUi.icons.iconBase + 'noun_492246.svg',
  name: 'editProfile',
  label: () => null,
  // don't use this in the normal solid-panes dispatching

  render: function (subject, context) {
    //console.log('@@@ render edit profile pane:  subject, context', subject, context)
    const dom = context.dom;
    const store = context.session.store;

    // Use <section> as the main container for better semantics
    const div = dom.createElement('section');
    div.setAttribute('data-testid', 'profile-editor');
    div.setAttribute('role', 'region');
    div.setAttribute('aria-label', 'Edit your profile');
    let editableProfile;

    // Use <main> for the main content area, styled as a grid like ProfileView
    const main = dom.createElement('main');
    main.setAttribute('id', 'profile-edit-main-content');
    main.setAttribute('aria-busy', 'true');
    main.setAttribute('tabindex', '-1');
    main.classList.add('profile-grid', 'no-focus-ring');
    const mainHeading = dom.createElement('h1');
    mainHeading.classList.add('visually-hidden');
    mainHeading.textContent = 'Edit Profile';
    main.appendChild(mainHeading);
    div.appendChild(main);

    // Use <aside> for the status area
    const statusArea = dom.createElement('aside');
    statusArea.classList.add('p-sm');
    statusArea.setAttribute('role', 'status');
    statusArea.setAttribute('aria-live', 'polite');
    statusArea.setAttribute('aria-atomic', 'true');
    const ensureStatusArea = () => {
      if (!statusArea.isConnected) {
        div.appendChild(statusArea);
      }
    };
    const profileContext = {
      dom: dom,
      div: main,
      statusArea: statusArea,
      me: null
    };
    _solidUi.login.ensureLoadedProfile(profileContext).then(theContext => {
      const me = theContext.me;
      const profile = me.doc();
      if (!store.updater) {
        throw new Error('Store has no updater');
      }
      if (store.any(me, _solidUi.ns.solid('editableProfile'))) {
        editableProfile = store.any(me, _solidUi.ns.solid('editableProfile'));
      } else if (store.updater.editable(profile.uri, store)) {
        editableProfile = profile;
      } else {
        ensureStatusArea();
        statusArea.appendChild(_solidUi.widgets.errorMessageBlock(dom, `⚠️ Your profile ${profile} is not editable, so we cannot do much here.`, 'straw'));
        return;
      }

      // Render each section as a card with consistent classes
      // Your contact information Section
      main.appendChild((0, _EditContactsCard.EditContactsSection)(context, me));

      // Resume Section
      main.appendChild((0, _EditCVCard.EditCVSection)(context, me, editableProfile, store));

      // Social Accounts Section
      main.appendChild((0, _EditSocialCard.EditSocialSection)(context, me, editableProfile, store));

      // Other preferences Section
      main.appendChild((0, _EditOtherPreferences.EditOtherPreferencesSection)(context, me, editableProfile, store));

      // People you know Section
      main.appendChild((0, _EditFriendsCard.EditFriendsSection)(context, me, editableProfile, profile));

      // Communities you participate in Section
      main.appendChild((0, _EditCommunitiesCard.EditProfileCommunitiesSection)(context, me, editableProfile, profile));
      main.setAttribute('aria-busy', 'false');
      main.focus();
    }).catch(error => {
      ensureStatusArea();
      statusArea.appendChild(_solidUi.widgets.errorMessageBlock(dom, error, '#fee'));
      main.setAttribute('aria-busy', 'false');
    });
    return div;
  }
};
var _default = exports.default = editProfileView;